import React from 'react';
import Logo from '../../images/logo.svg'
class Footer extends React.Component {
  render(){
    return(
        <footer className="space--sm footer-2 bg--dark ">
        <div className="container">
            <div className="row">
                <div className="col-md-6 col-lg-3 col-6">
                    <h6 className="type--uppercase">Company</h6>
                    <ul className="list--hover">
                        <li>
                            <a id="home--terms-of-service--footer-link" href="/terms-of-service">Terms of Service</a>
                        </li>
                        <li>
                            <a id="home--privacy-policy--footer-link" href="/privacy-policy">Privacy Policy</a>
                        </li>
                        <li>
                            <a id="home--contact-us--footer-link" href="/contact">Contact Us</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-6 col-lg-3 col-6">
                    <h6 className="type--uppercase">Support</h6>
                    <ul className="list--hover">
                        <li>
                            <a  id="home--help-center--footer-link" href="/help">Help Center</a>
                        </li>

                        <li>
                            <a id="home--support--and-contact--footer-link" href="/contact">Support & Contact</a>
                        </li>

                        <li>
                            <a id="home--service-status--footer-link" href="http://status.popupfox.com/" target="_blank">Service Status</a>
                        </li>
                    </ul>
                </div>

                <div className="col-md-6 col-lg-3 col-6">
                    <h6 className="type--uppercase">Blog</h6>
                    <ul className="list--hover">
                        <li>
                            <a  id="home--blog--footer-link" href="/blog">Blog</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/grow-social-media-following">Grow Social Media Following</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/what-is-customer-retention-rate-how-to-calculate-and-improve-it">What Is Customer Retention Rate? How to Calculate and Improve It</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/a-guide-to-lead-generation-what-is-it-how-to-improve-it">A Guide to Lead Generation: What Is It? How to Improve It?</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/exit-intent-popups-what-are-they-how-do-they-work">Exit Intent Popups: What Are They? How Do They Work?</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/what-are-b2c-and-b2b-marketing/">What Are B2C and B2B Marketing?</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/what-is-conversion-rate-and-how-to-improve-it">What Is Conversion Rate and How to Improve It?</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/blog/4-effective-popup-advertising-strategies">4 Effective PopUp Advertising Strategies</a>
                        </li>
                    </ul>
                </div>

                <div className="col-md-6 col-lg-3 col-6">
                    <h6 className="type--uppercase">Resources</h6>
                    <ul className="list--hover">
                        <li>
                            <a  id="home--blog--footer-link" href="/shopify-popup">Shopify Popup</a>
                        </li>

                        <li>
                            <a  id="home--blog--footer-link" href="/after-x-seconds-trigger">After X Seconds Trigger</a>
                        </li>
                        <li>
                            <a  id="home--blog--footer-link" href="/gamified-popup">Gamified Popup</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <span className="type--fine-print">©
                    <span className="update-year">2021</span> Popupfox Inc. 651 N Broad St. Suite 206 Middletown Delaware, 19709</span>
                </div>
                <div className="col-md-6 text-right text-left-xs">
                    <ul className="social-list list-inline list--hover">
                    {/*
                        <li>
                            <a href="#">
                                <i className="socicon socicon-google icon icon--xs"></i>
                            </a>
                        </li>
                    */}
                        <li>
                            <a id="home--twittericon--footer-link" href="https://twitter.com/popupfoxcom">
                                <i className="socicon socicon-twitter icon icon--xs"></i>
                            </a>
                        </li>
                        <li>
                            <a id="home--facebookicon--footer-link" href="https://facebook.com/popupfoxcom">
                                <i className="socicon socicon-facebook icon icon--xs"></i>
                            </a>
                        </li>
                        <li>
                            <a  id="home--instagramicon--footer-link" href="https://instagram.com/popupfox">
                                <i className="socicon socicon-instagram icon icon--xs"></i>
                            </a>
                        </li>
                        <li>
                        <a  id="home--linkedinicon--footer-link" href="https://linkedin.com/popupfox">
                            <i className="socicon socicon-linkedin icon icon--xs"></i>
                        </a>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    )
  }
}
export default Footer;